export default "__VITE_ASSET__CVD58AjS__"